// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35tV_","largestCol":"styles_largestCol__23_kN","smallestCol":"styles_smallestCol__1ePaI"};